import api from "./Api";

class OrdemServicoCamposAdicionaisService {
  GetPresets() {
    return api
      .get("/v1/OrdemServicoCamposAdicionais/Presets")
      .then((response) => {
        return response.data;
      });
  }

  GetPreset(payload) {
    return api
      .get("/v1/OrdemServicoCamposAdicionais/Presets/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetConfiguracaoAtiva() {
    return api
      .get("/v1/OrdemServicoCamposAdicionais/Configuracao")
      .then((response) => {
        return response.data;
      });
  }

  GetConfiguracoes() {
    return api
      .get("/v1/OrdemServicoCamposAdicionais/Configuracoes")
      .then((response) => {
        return response.data;
      });
  }

  PostConfiguracao(payload) {
    return api
      .post("/v1/OrdemServicoCamposAdicionais/Configuracao", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutConfiguracao(payload) {
    return api
      .put(
        "/v1/OrdemServicoCamposAdicionais/Configuracao/" + payload.id,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }

  DeleteConfiguracao(payload) {
    return api
      .delete("/v1/OrdemServicoCamposAdicionais/Configuracao/" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new OrdemServicoCamposAdicionaisService();
